module.exports = __webpack_public_path__ + "media/images/bnr-referal-sm-171dd969a6a0cb6d15140c56a90e37f9.png";